import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, createFormData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';

function ClientAdvanceInfo(props){
  const [loading, setLoading] = useState(false);
  const [bank, setBank] = useState(props.client.bank);
  const [bank_account, setBankAccount] = useState(props.client.bank_account);
  const [account_holder_name, setAccountHolderName] = useState(props.client.account_holder_name);
  const [ifsc_code, setIfsc] = useState(props.client.ifsc_code);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(bank && bank_account && account_holder_name && ifsc_code){
      setLoading(true);
      axios.post(global.config.api_server+'client',createFormData({
        bank: bank,
        bank_account: bank_account,
        account_holder_name: account_holder_name,
        ifsc_code: ifsc_code,
        token: localStorage.getItem("token"),
        client_id: props.id,
        task: 'advanced'
      })).then(res => {
        setLoading(false);
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Client updated');
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Some fields are required');
    }
  }

  return(
    <div className="card shadow mb-4">
      <div className="card-header py-3">      
        <button onClick={(e) => handleSubmit(e)} className={'btn btn-icon-split float-right btn-'+theme()}>
          <span className="icon text-white-50">
            <i className="fas fa-save"></i>
          </span>
          <span className="text">Save</span>
        </button>
        <h6 className={'mt-2 font-weight-bold text-'+theme()}>Client - Addiotnal Information</h6>
      </div>
      <div className="card-body">
        <div className="row">
          {loading === true ? (
            <Progress label='Saving' small={true}/>
          ):null}
          <div className="col-md-6">
            <div className="form-group">
              <label>Bank *</label>
              <input type="text" value={bank} maxLength="50" name="bank" className="form-control" id="bank" placeholder="Enter Bank Name" onChange={(e) => setBank(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Account Number *</label>
              <input type="text" value={bank_account} maxLength="50" name="bank_account" className="form-control" id="bank_account" placeholder="Enter Account Number" onChange={(e) => setBankAccount(e.target.value)}/>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Account Holder Name *</label>
              <input type="text" value={account_holder_name} maxLength="50" name="account_holder_name" className="form-control" id="account_holder_name" placeholder="Enter Account Holder Name" onChange={(e) => setAccountHolderName(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>IFSC Code *</label>
              <input type="text" value={ifsc_code} maxLength="15" name="ifsc_code" className="form-control" id="ifsc_code" placeholder="Enter IFSC Code" onChange={(e) => setIfsc(e.target.value)}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientAdvanceInfo;